import React, { useEffect, useState } from 'react';
import * as dateFns from 'date-fns';
import { Link } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';

import Loader from '../../../Shared/Loader';
import { fixDecimals, getFile, paramBuilder, saveDataEventsOnLocalStorage, text_truncate } from '../../../../helpers';
import Table, { RowsType } from '../../../Shared/CustomTable';
import Filters from '../Filters';
import { SERVER } from '../../../../config/server.config';
import ConfirmationModal from '../../../Shared/Modals/ConfirmationModal';
import { FILTER_GLOBAL_KEYS, FILTER_KEYS } from '../../../../config/constants';
import { useFiltersState, usePracticesDispatch, usePracticesState } from '../../../../store/hooks';
import { useRouter } from '../../../../helpers/customHooks';
import { message, notification } from 'antd';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';

export const TeamPracticesTab = () => {
  
  
  const practices = usePracticesState();
  const { pathname, search, params, specificScope } = useRouter();
  const {
    [FILTER_GLOBAL_KEYS.WEEKS]: weeks,
    [FILTER_KEYS.DATE_RANGE]: filterDateRangeData,
    [FILTER_KEYS.INTENSITY]: filterIntensityData
  } = useFiltersState(specificScope, FILTER_GLOBAL_KEYS.WEEKS, FILTER_KEYS.DATE_RANGE, FILTER_KEYS.INTENSITY);
  const { id } = params as { id: string };
  const { getPracticesByGameId } = usePracticesDispatch();
  const{ download } = useFlagsState();
  const {  fileIsDownloading } = useFlagsDispatch();

  useEffect(() => {
    saveDataEventsOnLocalStorage(practices.map((practice) => practice.dsid));
  }, [practices]);

  useEffect(() => {
    if (weeks && filterDateRangeData && filterDateRangeData.selectedDates && filterDateRangeData.selectedDates.length && filterIntensityData) {
      getPracticesByGameId(id, true)();
    }
  }, [weeks, filterDateRangeData, filterIntensityData]);

   // Exports Notification
   const notificationKey = 'downloadFinished';
   const notificationDownload = (name:string) => {
     const args = {
       key: notificationKey,
       message: 'Download In Progress',
       description:
         `Your file ${name} is being processed.`,
       duration: 0,
       icon: <i className='mdi mdi-download' style={{color: '#0378bf'}}></i>
     };
     notification.open(args);
   };
   const notificationDownloadFinish = (name:string) => {
     const args = {
       key: notificationKey,
       message: 'Download Finished',
       description: `Your file ${name} has been downloaded successfully.`,
       duration: 4,
       icon: <i className='mdi mdi-check-underline' style={{color: '#0378bf'}}></i>
     };
     notification.open(args);
   };
   const notificationDownloadError = (name:string) => {
     const args = {
       key: notificationKey,
       message: `Error downloading file ${name}`,
       duration: 4,
       icon: <i className='mdi mdi-alert' style={{color: 'red'}}></i>
     };
     notification.open(args);
   };
  
  const [modal, setModal] = useState<JSX.Element | null>(null);
  const headers = [
    // {
    //   content: (<><input className="styled-checkbox" id="checkbox-practices-head" type="checkbox" value="value1"/>
    //     <label htmlFor="checkbox-practices-head" className="check-l"/></>),
    //   class: 'oo-i'
    // },
    { content: 'NAME', isOrderly: true, style: { paddingLeft: '20px', width: '145px' } },
    { content: 'DATE/TIME', isOrderly: true, style: { width: '146px' } },
    { content: 'INTENSITY', isOrderly: true, style: { width: '76px' } },
    { content: 'AVG. MAX SPEED', class: 'll-pp', isOrderly: true, style: { paddingLeft: '18px', width: '98px' } },
    { content: 'AVG. MAX SUST. SPEED', class: 'll-pp', isOrderly: true, style: { paddingLeft: '18px', width: '98px' } },
    { content: 'AVG. TTL DIST.', class: 'll-pp', isOrderly: true, style: { paddingLeft: '18px', width: '88px' } },
    // {content: 'AVG. HARD EFF. DIST.', width: '6.5%', class: 'll-pp', isOrderly: true, style: {paddingLeft: '27px'}},
    { content: 'AVG. ACCEL CT.', class: 'll-pp', isOrderly: true, style: { width: '50px' } },
    { content: 'AVG. DECEL CT.', class: 'll-pp', isOrderly: true, style: { width: '50px' } },
    { content: '', style: { width: '525px' } }
  ];
  const rows: RowsType<string, number, JSX.Element> = [];
  practices.forEach((practice, index) => {
    rows.push({
      columns: [
        // {
        //   class: 'oo-i',
        //   content: (<><label className="l-c">
        //     <input className="styled-checkbox" id={'checkbox-practices-' + index} type="checkbox" value="value2"/>
        //     <label htmlFor={'checkbox-practices-' + index} className="check-l"/>
        //   </label></>),
        //   // style: {width: '1%'}
        // },
        {
          content: practice.name,
          print: (content: string) => <label className="l-c"><b> {text_truncate(content, 20)}</b></label>,
          order: (contentA: string, contentB: string) => contentA.localeCompare(contentB),
          style: { paddingLeft: '20px' }
        },
        {
          content: practice.startTime,
          print: (content: number) => (
            <label className="l-c">{dateFns.format(new Date(content), 'MM/dd/yyyy, hh:mma')}</label>
          ),
          order: (contentA: number, contentB: number) => contentA - contentB
        },
        {
          content: text_truncate(practice.intensity, 10),
          print: (content: string) => <label className="l-c">{content}</label>,
          order: (contentA: string, contentB: string) => contentA.localeCompare(contentB)
        },
        {
          class: 'll-pp',
          content: practice.aveMaxSpeedMPH,
          print: (content: number) => (<label className="l-c">{fixDecimals(content, 1)}</label>), // style: {width: '8%'}
          order: (contentA: number, contentB: number) => contentA - contentB
        },
        {
          class: 'll-pp',
          content: practice.aveMaxSustainedSpeedMPH,
          print: (content: number) => <label className="l-c">{fixDecimals(content, 1)}</label>, //style: {width: '8%'}
          order: (contentA: number, contentB: number) => contentA - contentB
        },
        {
          class: 'll-pp',
          content: practice.totalAveDist,
          print: (content: number) => <label className="l-c">{fixDecimals(content, 0)}</label>,// style: {width: '7%'},
          order: (contentA: number, contentB: number) => contentA - contentB
        },
        // {
        //   class: 'll-pp',
        //   content: {aveHardEffortDist: practice.aveHardEfforDistanceTeam},
        //   print: (content) => <label
        //     className="l-c">{isNaN(content.aveHardEffortDist) ? '-' : fixDecimals(content.aveHardEffortDist, 0)}</label>, //style: {width: '6.5%'}
        //   order: (contentA, contentB) => contentA.aveHardEffortDist - contentB.aveHardEffortDist,
        // },
        {
          class: 'll-pp',
          content: practice.totalAveAccels,
          print: (content: number) => (
            <label className="l-c">{fixDecimals(content, 0)}</label>
          ),
          order: (contentA: number, contentB: number) => contentA - contentB
        },
        {
          class: 'll-pp',
          content: practice.totalAveDecels,
          print: (content: number) => (
            <label className="l-c">{fixDecimals(content, 0)}</label>
          ),
          order: (contentA: number, contentB: number) => contentA - contentB
        },
        {
          class: 'oo-u',
          content: (
            <>
              <Button
                disabled={download}
                className="btn-blue"
                onClick={async () => {
                  fileIsDownloading(true);
                  notificationDownload(`${practice.dsid}.csv`);
                  const done = await getFile(SERVER.CSV_REPORT(practice.dsid/*, teamId*/) + paramBuilder({ tzOffset: -(new Date(practice.startTime).getTimezoneOffset()) }), `${practice.dsid}.csv`);
                  if (done) {
                    fileIsDownloading(false);
                    notificationDownloadFinish(`${practice.dsid}.csv`);
                  } else {
                    fileIsDownloading(false);
                    notificationDownloadError(`${practice.dsid}.csv`);
                  }
                }}
              >
                Export
              </Button>
              <Link
                to={{
                  pathname: `/view/practice/${practice.dsid}/performance/condensed/page`,
                  state: { toReturn: pathname, toReturnSearch: search }
                }}
              >
                <Button className="btn-blue"> View Full Practice Data</Button>
              </Link>
            </>
          )
        }
      ],
      id: index + ''
    });
  });
  return (
    <>
      {modal}
      <Filters teamId={id}/>
      <div className="performance-body" style={{ height: 'calc(100vh - 175px)' }}>
        <Loader forceLoader={!weeks}>
          <Table
            headers={headers}
            rows={rows}
            default={{ orderColumn: 2 }}
            isSelectedStyle
          />
        </Loader>
      </div>
    </>
  );
};

export default TeamPracticesTab;